export default "__VITE_ASSET__DDf$kXIv__"